<template>
  <tr>
    <td class="col1 text-center" colspan="3">{{ $t('特別評価') }}</td>
    <td v-for="user in evaluatees" :colspan="numColsPerStaff">
      <div v-if="!user.finalEvaluation.isClosed() && canEdit">
        <input
          :form="formId"
          class="form-control text-center"
          type="number"
          step="0.01"
          :name="`additional_points[${user.id}]`"
          v-model.number="user.additionalPoint"
        >
      </div>
      <div v-else class="text-center">{{ user.additionalPoint }} {{ scoreType == 'AVERAGE' ? '%' : '点' }}</div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'tr-additional-points',
  props: {
    evaluatees: {
      type: Object,
      required: false,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
    formId: {
      type: String,
      required: true,
    },
    numColsPerStaff: {
      type: Number,
      required: true,
    },
    scoreType: {
      type: String,
      required: true
    }
  }
}
</script>
